export default {
    SERVICE_END_POINT_DEV:"http://localhost",
    SERVICE_END_POINT_PROD:"https://wordoflivinggod.com",
    SERVICE_API_PROD:"",
    SERVICE_API_DEV:"/curriculum",
    MEDIA_API_V1 : "/media/v1",
    MEDIA_API_DEV : "/curriculum/media/v1",
    MEDIA_API_DOWNLOAD : "/media/download",
    MEDIA_API_DOWNLOAD_DEV : "/curriculum/media/download",
    ADMIN_REPORT_API_DOWNLOAD : "/api/admin/report/download",
    ADMIN_REPORT_API_DOWNLOAD_DEV : "/curriculum/api/admin/report/download",
}